/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { NbAuthModule } from '@nebular/auth';
import { NbFirebaseAuthModule, NbFirebasePasswordStrategy, NbFirebaseGoogleStrategy } from '@nebular/firebase-auth';
import { environment } from 'environments/environment';
import { AuthFirebaseService } from './auth-firebase.service';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';

import { provideStorage, getStorage } from '@angular/fire/storage';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { VisorSigpacNgLibModule } from 'visor-sigpac-ng-lib';
import { NbCardModule, NbTooltipModule } from '@nebular/theme';
import { MatExpansionModule } from '@angular/material/expansion';

registerLocaleData(localeEs);
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbIconModule,
  NbButtonModule,
  NbIconLibraries
} from '@nebular/theme';
import { AuthGuard } from './auth-guard.service';
import { FirebaseRepositoryService } from './firebase-repository.service';
import { BotonAddRegistroComponent } from './components/boton-add-registro/boton-add-registro.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { DynamicViewerComponent } from './components/dynamic-viewer/dynamic-viewer.component';
import { NbTimepickerModule } from '@nebular/theme';
import { NbSelectModule } from '@nebular/theme';
import { NbDateFnsDateModule } from '@nebular/date-fns';
import { EstadoTareaComponent } from './components/estado-tarea/estado-tarea.component';
import { DialogAsignarTrabajadorComponent } from './components/dialog-asignar-trabajador/dialog-asignar-trabajador.component';
import { VerRegistroButtonComponent } from './components/ver-registro-button/ver-registro-button.component';
import { TaskDetailComponent } from './components/task-detail/task-detail.component';
import { ColAutorizacionCueComponent } from './components/col-autorizacion-cue/col-autorizacion-cue.component';
import { AutorizarTitularComponent } from './components/autorizar-titular/autorizar-titular.component';
import { SolicitarAutorizacionComponent } from './components/solicitar-autorizacion/solicitar-autorizacion.component';
import { ImportarRecintosComponent } from './components/importar-recintos/importar-recintos.component';
import { NbSpinnerModule } from '@nebular/theme';
import { BotonesParcelaComponent } from './components/botones-parcela/botones-parcela.component';
import { EditarRecintoComponent } from './pages/editar-recinto/editar-recinto.component';

@NgModule({
  declarations: [AppComponent, BotonAddRegistroComponent, DynamicViewerComponent, EstadoTareaComponent, DialogAsignarTrabajadorComponent, VerRegistroButtonComponent, TaskDetailComponent, ColAutorizacionCueComponent, AutorizarTitularComponent, SolicitarAutorizacionComponent, ImportarRecintosComponent, BotonesParcelaComponent, EditarRecintoComponent],
  imports: [
    NbSpinnerModule,
    NbCardModule,
    MatExpansionModule,
    BrowserModule,
    FormsModule,
    AngularFireModule.initializeApp(environment.firebase),
    provideFirebaseApp(() => initializeApp(environment.firebaseFito, '[FITO]')),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideFirestore(() => getFirestore('(default)')),
    provideStorage(() => getStorage()),
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    NgxEchartsModule.forRoot({ echarts }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    AngularFireAuthModule,
    NbIconModule,
    NbButtonModule,
    NbSelectModule,
    VisorSigpacNgLibModule.forRoot({ provide: 'SENTINEL_URLS', useValue: {
            } }, {
            provide: 'SIGPAC_HOST', useValue: 'https://sigpac.mapa.es'
        }, {
            provide: 'UI_SETTINGS', useValue: undefined
        }),
        NbTooltipModule,
    NbDatepickerModule.forRoot(),
    NbDateFnsDateModule,
    NbTimepickerModule.forRoot(),
  ],
  providers:[AuthFirebaseService,FirebaseRepositoryService, { provide: LOCALE_ID, useValue: 'es-ES' }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private iconLibraries: NbIconLibraries) {
    this.iconLibraries.registerFontPack('font-awesome', {
      packClass: 'fa',
      iconClassPrefix: 'fa',
    });
  }
}
